import axios from 'axios';

export const createInvite = axios.create({
  url: '/sebTariff/createInvite',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  method: 'post',
});
